module.exports = __webpack_public_path__ + "img/black-round-plus.341bad41.svg";